// SearchBar.jsx
import React from 'react';
import { InputGroup, Form, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const SearchBar = ({ searchQuery, onSearchChange, selectedCount, onLinkClick, isProcessing }) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex gap-3 align-items-start">
      <InputGroup>
        <InputGroup.Text>
          <i className="bi bi-search" />
        </InputGroup.Text>
        <Form.Control
          placeholder={t('pages.workflow.searchInSuggestions')}
          value={searchQuery}
          onChange={onSearchChange}
        />
      </InputGroup>

      <Button 
        variant="primary"
        onClick={onLinkClick}
        disabled={selectedCount === 0 || isProcessing}
        className="d-flex align-items-center gap-1 text-nowrap"
      >
        {isProcessing ? (
          <>
            <Spinner animation="border" size="sm" className="me-2" />
            {t('pages.workflow.linking')}...
          </>
        ) : (
          <>
            <i className="bi bi-link-45deg" />
            {t('pages.workflow.linkSelected')} ({selectedCount})
          </>
        )}
      </Button>
    </div>
  );
};

export default SearchBar;